import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
export const ErrorMessage = ({ message, ...rest }) => {
    if (message)
        return _jsx(Message, { ...rest, children: message });
    return null;
};
const Message = styled.div `
  ${({ theme }) => theme.getFontStyle('samsung-700-16')};
  color: ${({ theme }) => theme.getColor('error', 'default')};

  width: 100%;
  text-align: center;
  margin-bottom: 2.4rem;
  white-space: pre-line;
`;
//# sourceMappingURL=ErrorMessage.js.map